import React, { useState } from "react";
import Nav from "./Nav.jsx";
import "./Nav.css";

export default function SearchBar({ onSearch }) {
  const [clima, setClima] = useState("");
  console.log(clima);
  const onChange = (e) => {
    setClima(e.target.value);
  };
  const onEnter = (e) => {
    if (e.keyCode === 13) {
      if (typeof onSearch === "function") {
        onSearch(clima);
        setClima("");
        document.getElementById("search").value = "";
      }
    }
  };
  function buscar(event) {
    event.preventDefault();
    var input;
    if (typeof onSearch === "function") {
      onSearch(clima);
      setClima("");
      document.getElementById("search").value = "";
    }
  }
  return (
    <header class="header">
      <div className="w-100 content text-light">
        <Nav />
        <div className="col-6 text-right">
          <div class="">
            <input
              type="text"
              className="input"
              id="search"
              style={{ height: 35 }}
              placeholder="Ingrese una ciudad"
              onChange={onChange}
              onKeyDown={onEnter}
            />
            <button
              className="btn btn-outline-secondary align-middle mb-1 ml-2 button"
              type="submit"
              onClick={buscar}
            >
              Buscar
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
